import ArrowRightIcon from '../../assets/icons/chevron-right--yellow.svg';
import LinkIcon from '../../assets/icons/chain--yellow.svg';
import type { MeetingRoom } from '../../containers/MeetingRoom/meetingRoomSlice/types';
import {
  MeetingRoomItemContainer,
  SDataContainer,
  SDescription,
  SLink,
  SLinkContainer,
  STitle,
} from './MeetingRoomItem.styles';
import { formatUrlAsDmainName } from './helpers';

export type MeetingRoomItemProps = {
  meetingRoom: MeetingRoom;
  onMeetingRoomClick: (meetingRoomLink: string) => void;
};

export const MeetingRoomItem = (props: MeetingRoomItemProps) => {
  const { meetingRoom, onMeetingRoomClick } = props;
  const { name, description, url } = meetingRoom;

  return (
    <MeetingRoomItemContainer onClick={() => onMeetingRoomClick(meetingRoom.url)}>
      <SDataContainer>
        <STitle>{name}</STitle>
        {description && <SDescription>{description}</SDescription>}

        <SLinkContainer>
          <img src={LinkIcon} alt="link icon" />
          <SLink>{formatUrlAsDmainName(url) || url}</SLink>
        </SLinkContainer>
      </SDataContainer>

      <img src={ArrowRightIcon} alt="right arrow" />
    </MeetingRoomItemContainer>
  );
};
